import definition from './things.service';
import Constant from './things.config';

/**
 * ThingsApi settings
 * @type {{name: string, definition: ThingsApi}}
 */
const Service = {
    name: 'ThingsApi',
    definition
};

export {
    Service,
    Constant
};



// WEBPACK FOOTER //
// ./app/services/api/things/index.js